import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../EntityImage';

const SMALL_MOBILE = '(max-width: 399px)';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-600']};
  width: 100%;
`;

export const TopRowLink = styled.a`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-600']};
  width: 100%;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover .basket-card-title,
  &:focus-visible .basket-card-title {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid currentColor;
    outline-offset: ${space['space-050']};
    border-radius: ${size.radius['radius-xs']};
  }
`;

export const Thumbnail = styled.div`
  flex-shrink: 0;
  width: ${space['space-2400']};
  height: ${space['space-2400']};
  border-radius: ${size.radius['radius-xs']};
  overflow: hidden;
  background: ${semantic.bg.surfaceSubtle};

  @media ${SMALL_MOBILE} {
    width: ${space['space-1600']};
    height: ${space['space-1600']};
  }
`;

export const ThumbnailImage = styled(EntityImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  text-align: center;
  padding: ${space['space-200']};
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  gap: ${space['space-600']};
  align-items: flex-start;

  @media ${SMALL_MOBILE} {
    gap: ${space['space-400']};
  }
`;

export const TextColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
`;

export const MetaList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const MetaItem = styled.li`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
`;

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  flex-shrink: 0;
  gap: ${space['space-0']};
`;

export const SubPriceRow = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
`;

export const RemoveRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const RemoveButton = styled.button`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;
